import React, { type ReactNode } from 'react';

export const DEFAULT_LTA_BANNER_COPY = "You're enjoying [tier] for free until [end_date].";

const TOKEN_RE = /(\[tier\]|\[end_date\])/g;

interface Substitutions {
  tier: ReactNode;
  endDate: ReactNode;
}

const applyLtaBannerCopyPlaceholders = (
  copy: string,
  { tier, endDate }: Substitutions,
): ReactNode => {
  const parts = copy.split(TOKEN_RE);
  return parts.map((part, i) => {
    if (part === '[tier]') return <React.Fragment key={i}>{tier}</React.Fragment>;
    if (part === '[end_date]') return <React.Fragment key={i}>{endDate}</React.Fragment>;
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};

export default applyLtaBannerCopyPlaceholders;
